import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'
import sortListStringNum from '../../../../helper/sortLIstStringNum'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListIncustNotRegFullFinger = `${host}admin/exportJSON/incustNotRegisterFullFinger`

export const getListIncustNotRegFullFinger = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    CustomerNumber,
    TellerName,
    SupervisorName
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
        CustomerNumber,
        TellerName,
        SupervisorName
    })

    try {
        const res = await Axios.post(
            apiGetListIncustNotRegFullFinger,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_NUM_OF_NOT_REG_BIO,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                    CustomerNumber,
                    TellerName,
                    SupervisorName
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_NUM_OF_NOT_REG_BIO_ERROR,
            () => false
        )
    }
}

export const exportListIncustNotRegFullFinger = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    CustomerNumber,
    BranchCodes,
    TellerName,
    SupervisorName
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
        CustomerNumber,
        TellerName,
        SupervisorName
    })

    try {
        const res = await Axios.post(
            apiGetListIncustNotRegFullFinger,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${sortListStringNum(BranchCodes).join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
